export default "__VITE_ASSET__f84a960b__"